import {
  CONTROL_EDIT_BENEFIT,
  UPDATE_UI_DATA,
  SELECT_DOCUMENT,
  RESET_SELECT_DOCUMENT,
  ADD_FILE_TO_LIST,
  REMOVE_FILE_FROM_LIST,
  CHECKBOX_STATUS_UPDATE,
  CONTROL_DECLARATION,
  EDIT_ALL_INVALID_FORM,
  EDIT_UPLOAD,
  UPDATE_DOCUMENT_MANDATORY,
  REMOVE_FROM_DOCUMENT_LIST,
} from "../actions"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialUiData = {
  draftFolderPrefix: "Life_",
  pageNumber: 1,
  maxPageNumber: 1,
  showLoading: true,
  showDeclaration: false,
  occupationList: [],
  bankList: [],

  // ===== UPLOAD START =====
  proofDocuments: [],
  folderName: null,
  totalFileSize: 0,
  compressedFilesize: 0,
  exceededFileSizeLimit: false,
  lockUploadDropdown: false,
  isEditUpload: false,
  claimUploadListModel: [],
  tempSelectedDocument: {
    documentId: 0,
    documentDesc: "Please select your document name",
  },
  // ===== UPLOAD END =====

  checkBoxStatus: {
    isAgree: false,
  },
  submittedClaimID: "",
  editBenefits: {
    "Loss Details": false,
    "Claims Payout Instruction": false,
  },
  clickedNext: {
    // Number below is pageNumber
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  },
  formIsValid: {},
  witnessFieldIsEmpty: false,
}

const uiDataReducer = (state = initialUiData, action) => {
  const newState = Object.assign({}, state)
  let property = action.property

  switch (action.type) {
    case UPDATE_UI_DATA:
      return {
        ...state,
        [property]: action.newData,
      }
    case SELECT_DOCUMENT:
      newState.tempSelectedDocument = {
        documentId: action.documentId,
        documentDesc: action.documentDesc,
      }
      return newState

    case RESET_SELECT_DOCUMENT:
      newState.tempSelectedDocument = {
        documentId: 0,
        documentDesc: "Please select your document name",
      }
      return newState

    case ADD_FILE_TO_LIST:
      newState.claimUploadListModel.push({
        fileName: action.fileName,
        documentId: action.documentId,
        filePath: action.filePath,
        fileSize: action.fileSize,
        folderName: action.folderName,
        compressedFilesize: action.compressedFilesize,
      })

      newState.totalFileSize += action.compressedFilesize

      return newState

    case REMOVE_FILE_FROM_LIST:
      let indexOfUploadedDocumentArray = newState.claimUploadListModel
        .map(function(e) {
          return e.fileName
        })
        .indexOf(action.fileName)
      newState.claimUploadListModel.splice(indexOfUploadedDocumentArray, 1)
      newState.totalFileSize -= action.fileSize
      return newState

    case CONTROL_EDIT_BENEFIT:
      newState.editBenefits[action.formName]
        ? (newState.editBenefits[action.formName] = false)
        : (newState.editBenefits[action.formName] = true)
      return newState

    case CHECKBOX_STATUS_UPDATE:
      !newState.checkBoxStatus[action.checkboxName]
        ? (newState.checkBoxStatus[action.checkboxName] = true)
        : (newState.checkBoxStatus[action.checkboxName] = false)
      return newState

    case CONTROL_DECLARATION:
      newState.showDeclaration
        ? (newState.showDeclaration = false)
        : (newState.showDeclaration = true)
      return newState

    case EDIT_ALL_INVALID_FORM:
      newState.editBenefits = {}

      action.formlist.forEach((formlistItem, formlistKey) => {
        newState.editBenefits[formlistItem] = true
      })
      return newState

    case EDIT_UPLOAD:
      newState.isEditUpload = true
      newState.pageNumber = 2
      return newState

    case UPDATE_DOCUMENT_MANDATORY:
      let indexOfTargetDocumentId = newState.proofDocuments
        .map(function(e) {
          return e.documentId
        })
        .indexOf(action.targetDocumentId)

      newState.proofDocuments[indexOfTargetDocumentId].mandatory =
        action.updatedValue

      return newState

    case REMOVE_FROM_DOCUMENT_LIST:
      let indexOfDocumentIdWillDelete = newState.proofDocuments
        .map(function(e) {
          return e.documentId
        })
        .indexOf(action.targetDocumentId)

      newState.proofDocuments.splice(indexOfDocumentIdWillDelete, 1)

      return newState
    default:
      return newState
  }
}

export default uiDataReducer
